<template>
  <div>
    <v-popover
      v-for="(letter, ind) in letters"
      :key="ind"
      class="d-inline"
      placement="bottom"
      :auto-hide="true"
    >
      <i
        v-bind:class="{
          'icon-fa icon-fa-envelope': true,
          green: letter.sended,
          red: !letter.sended
        }"
      ></i>
      <template slot="popover">
        <div class="letters_info">
          <p>{{ getLetterType(letter) }}</p>
          <p class="text-muted">{{ letter.created_at }}</p>
          <p>{{ getLetterMessage(letter) }}</p>
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script>
export default {
  props: ["letters"],
  data() {
    return {
      types: {
        1: "Поступление почтовой заявки",
        2: "Письмо с реквизитами оплаты",
        3: "Поступление курьерской заявки"
      }
    };
  },
  computed: {
    $LetterTypes() {
      return this.$store.getters["orders/letterTypes"];
    }
  },
  methods: {
    getLetterType(letter) {
      if (this.$LetterTypes) {
        return this.types[this.$LetterTypes[letter.letter_id]];
      }
    },
    getLetterMessage(letter) {
      if (!letter.sended) {
        return letter.info;
      }
    }
  }
};
</script>

<style scoped>
.icon-fa {
  cursor: pointer;
}
.icon-fa-envelope.red {
  color: red;
}
.icon-fa-envelope.green {
  color: green;
}
</style>

<style>
.letters_info {
  text-align: left;
  color: #595959;
}
.letters_info p {
  margin-bottom: 2px;
}
</style>
